import React from 'react';
import moment from 'moment';
import { Icon_ChevronLeft, Icon_ChevronRight } from '../../Icons/icons';
import "./customHeader.less"

interface CustomHeaderProps {
  date: Date;
  changeYear: (year: number ) => void;
  changeMonth: (month: number) => void;
  showYearPicker: boolean;
  showMonthPicker: boolean;
  setShowYearPicker: (yearPicker: boolean) => void;
  setShowMonthPicker: (monthPicker: boolean) => void;
}

const CustomHeader: React.FC<CustomHeaderProps> = ({
  date,
  changeYear,
  changeMonth,
  showYearPicker,
  showMonthPicker,
  setShowYearPicker,
  setShowMonthPicker
}) => {
  return (
    <div className="custom-header">
        <div className="prev-arrows">
          <div onClick={() => changeYear((date.getFullYear() - 1))}>
            <Icon_ChevronLeft fill="none" />
            <Icon_ChevronLeft fill="none" />
          </div>
          { 
            !(showYearPicker) &&
            <div onClick={() => changeMonth(date.getMonth() - 1)}>
              <Icon_ChevronLeft fill="none" />
            </div>
          }
        </div>
        <div className="date p1">
          <div onClick={() => setShowYearPicker(true)}>{moment(date).format("YYYY")}</div>
          { 
            !(showYearPicker || showMonthPicker) &&
              <div onClick={() => setShowMonthPicker(true)}>{moment(date).format("MMM")}</div>
          }
        </div>
        <div className="next-arrows">
          { 
            !(showYearPicker) &&
            <div onClick={() => changeMonth(date.getMonth() + 1)}>
              <Icon_ChevronRight fill="none" />
            </div>
          }
          <div onClick={() => changeYear((date.getFullYear() + 1))}>
            <Icon_ChevronRight fill="none" />
            <Icon_ChevronRight fill="none" />
          </div>
        </div>
    </div>
  );
};

export default CustomHeader;
